/* GrokBot T FINAL (30 Oct): Ficha Técnica tiles (País, Região, Castas, Colheita, Tipo,
   Produtor/Destilaria, Enólogo, Idade, Estilo, Grau, Garrafa, …) are ANCHORED at the
   pressed button in the liquid-glass style (assets/vg-casta-pop.js/.css, .vgcp-ov).
   Never centred. This file does NOT route Ficha tiles.
   ONLY the Perfil do Vinho '?' and its bars use the full centred pop-up (dialog.vgp2-dlg
   and legacy .vgfc-m--pf). Do not widen scope. Do not claim to 'route all'. */
(function () {
  if (window.__vgpr) return;
  window.__vgpr = 1;
  var D = document, H = D.documentElement, RM = matchMedia('(prefers-reduced-motion: reduce)');
  var cur = null, lastF = null;

  function isPerfil(m) {
    return !!(m && m.classList && (m.classList.contains('vgp2-dlg') || m.classList.contains('vgfc-m--pf')));
  }

  function openDlg(m) {
    if (!m) return;
    if (m.tagName === 'DIALOG' && m.showModal) {
      try { if (!m.open) m.showModal(); } catch (e) { m.setAttribute('open', ''); }
      return;
    }
    openSheet(m, null);
  }

  function wire(m) {
    if (m.__pr) return;
    m.__pr = 1;
    m.addEventListener('click', function (e) {
      if (cur !== m) return;
      if (e.target === m || e.target.closest('[data-vgfc-close],.vgfc-m__x,[data-vgp2-close],.vgp2-dlg__x')) {
        e.preventDefault();
        e.stopPropagation();
        close();
      }
    });
  }

  function openSheet(m, from) {
    if (!m) return;
    if (cur && cur !== m) close(1);
    [].forEach.call(D.querySelectorAll('.vgcp-ov'), function (o) { o.hidden = true; });
    if (m.parentNode !== D.body) D.body.appendChild(m);
    wire(m);
    lastF = from || D.activeElement;
    cur = m;
    m.hidden = false;
    m.classList.remove('is-open');
    void m.offsetWidth;
    m.classList.add('is-open');
    H.classList.add('vgfc-lock');
    var p = m.querySelector('.vgfc-m__p');
    if (p) { p.scrollTop = 0; p.style.removeProperty('--drag'); }
    setTimeout(function () {
      var x = m.querySelector('.vgfc-m__x,.vgp2-dlg__x');
      x && x.focus({ preventScroll: true });
    }, 30);
  }

  function close(inst) {
    var m = cur;
    if (!m) return;
    cur = null;
    m.classList.remove('is-open');
    H.classList.remove('vgfc-lock');
    if (m.tagName === 'DIALOG' && m.open && m.close) {
      try { m.close(); } catch (e) { m.removeAttribute('open'); }
    } else {
      setTimeout(function () { if (cur !== m) m.hidden = true; }, (inst || RM.matches) ? 0 : 320);
    }
    if (!inst && lastF && lastF.focus) lastF.focus({ preventScroll: true });
  }

  function gate(f) {
    if (!f || f.__g) return f;
    var g = function (ms, from) {
      var a = [].filter.call(ms || [], Boolean);
      if (a.length && a.some(isPerfil)) {
        openDlg(a.filter(isPerfil)[0] || a[0]);
        return true;
      }
      return f.apply(this, arguments);
    };
    g.__g = 1;
    return g;
  }

  var _cp = gate(window.vgcpOpen);
  try {
    Object.defineProperty(window, 'vgcpOpen', {
      configurable: true,
      get: function () { return _cp; },
      set: function (v) { _cp = gate(v); }
    });
  } catch (e) {}

  D.addEventListener('keydown', function (e) {
    if (cur && e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();
      close();
    }
  }, true);

  /* If anything tries to put an open Perfil dialog into the anchored bubble, hide the bubble. */
  new MutationObserver(function () {
    var dlg = D.querySelector('dialog.vgp2-dlg[open], .vgfc-m--pf.is-open');
    var o = D.querySelector('.vgcp-ov:not([hidden])');
    if (dlg && o) o.hidden = true;
  }).observe(H, { subtree: true, attributes: true, attributeFilter: ['hidden', 'open', 'class'] });

  window.vgpr = { open: openDlg, close: close, perfilOnly: true };
})();
